import OpportunityEventLine from "./OpportunityEventLine";
import OpportunityMetaRow from "./OpportunityMetaRow";
import OpportunityHashtagRow from "./OpportunityHashtagRow";
import OpportunityExpandedContent from "./OpportunityExpandedContent";
import { getOpportunityBody } from "../../../utils/opportunityCard";

export default function OpportunityCardDetails({ opportunity }) {
    const {
        industry,
        category,
        eventName,
        relevanceScore,
        opportunity: opportunityText,
        engagementAngles = [],
        contentAngles = [],
        hashtags = [],
    } = opportunity ?? {};

    const body = getOpportunityBody(opportunity);

    return (
        <article className="space-y-4">
            {body ? (
                <p className="mb-0 break-words text-sm leading-relaxed text-slate-600 md:text-base">
                    {body}
                </p>
            ) : null}

            <OpportunityEventLine eventName={eventName} />

            <OpportunityMetaRow
                industry={industry}
                category={category}
                relevanceScore={relevanceScore}
            />

            <OpportunityHashtagRow hashtags={hashtags} size="md" />

            <OpportunityExpandedContent
                engagementAngles={engagementAngles}
                contentAngles={contentAngles}
                opportunity={
                    String(opportunityText ?? "").trim() !== String(body ?? "").trim()
                        ? opportunityText
                        : ""
                }
            />
        </article>
    );
}
